import React from 'react';
import PropTypes from 'prop-types';
import { useConnect } from '@lore/query-connect';
import { PayloadStates } from '@lore/utils';
import Loader from '../../../components/Loader';
import LocationMap from '../../profile/organizations/LocationMap';
import classNames from 'classnames';
import { DialogManager } from '../../../dialogs_new/DialogManager';
import useDialogLauncher from '../../../dialogs-routable/_hooks/useDialogLauncher';
import Card from '../../../components/Card';
import { CheckIcon, XMarkIcon } from '@heroicons/react/24/outline';
import titleCase from '@/utils/titleCase';

Role.propTypes = {
  role: PropTypes.object.isRequired,
  onClick: PropTypes.func.isRequired
};

export default function Role(props) {
  const {
    role,
    showActiveStatus = false,
    onClick
  } = props;

  const site = useConnect('site.byId', {
    id: role.data.siteId
  });

  const launch = useDialogLauncher();

  function onUpdateRole() {
    launch(DialogManager.RoleUpdate.Config(role.id));
  }

  function onDestroyRole() {
    launch(DialogManager.RoleDestroy.Config(role.id));
  }

  if (site.state === PayloadStates.FETCHING) {
    return (
      <Loader />
    );
  }

  return (
    <Card
      className={classNames(
        // 'flex flex-col bg-white shadow rounded-xl overflow-hidden',
        'hover:shadow-mdx hover:bg-cs-orange-50 relative z-10'
      )}
    >
      <div
        className="w-full h-48 opacity-70 cursor-pointer"
        onClick={() => onClick(site)}
      >
        <LocationMap location={site} />
      </div>
      <div
        className="flex flex-col sm:flex-row items-start sm:items-center overflow-hidden px-6 pt-4 pb-3 cursor-pointer justify-between gap-1"
        onClick={() => onClick(site)}
      >
        <div className="flex-1">
          <div>
            <h2 className="font-semibold text-cs-gray-900">
              {site.data.name}
            </h2>
          </div>
          <div className="flex justify-between mt-2x">
            <div className="text-sm text-cs-gray-500">
              {titleCase(site.data.addressLine1)}, {titleCase(site.data.city)}, {site.data.state}
            </div>
          </div>
        </div>
        {showActiveStatus && (
          <div className="flex items-center self-start">
            {site.data.isActive ? (
              <div className="flex items-center space-x-1 text-green-600">
                <CheckIcon className="h-5 w-5 text-green-600" />
                <div className="text-sm">Active</div>
              </div>
            ) : (
              <div className="flex items-center space-x-1 text-gray-500">
                <XMarkIcon className="h-5 w-5 text-gray-500" />
                <div className="text-sm">Inactive</div>
              </div>
            )}
          </div>
        )}
      </div>
      <div className="bg-cs-gray-50x px-6 pt-1x pb-4">
        <div className="flex justify-between mt-2x">
          {/*<div className="text-sm text-cs-blue-500 cursor-pointer hover:underline" onClick={() => onUpdateRole(role)}>*/}
          {/*  Edit role*/}
          {/*</div>*/}
          <div className="text-sm text-cs-blue-500 cursor-pointer hover:underline" onClick={() => onDestroyRole(role)}>
            No longer work here?
          </div>
        </div>
      </div>
    </Card>
  );
}
